var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "af-rails-client@fe02c08d51128fbcdffeae73a91bf49d640c8579"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["af-rails-client@glimpseai"] = {
  id: "af-rails-client@fe02c08d51128fbcdffeae73a91bf49d640c8579"
};